import ClassNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import styles from "../stylesheets/components/editor-ui-controls.module.css";

interface Props {
  right?: boolean;
  children: ReactNode;
}

const EditorUIControls: FunctionComponent<Props> = ({ right, children }) => {
  return (
    <ul
      className={ClassNames(styles.EditorUIControls, {
        [styles["EditorUIControls--right"]]: right,
      })}
    >
      {children}
    </ul>
  );
};

export default EditorUIControls;
